import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { AxerveSharedResponseDTO } from './models/AxerveSharedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class ContratarService {
  private contratarUrl = "";
  private contratarFinalUrl = "";


  constructor(private http: HttpClient, @Inject(APP_BASE_HREF) private baseHref: string) {
    this.contratarUrl = baseHref + environment.apis.payment;
    this.contratarFinalUrl = `${baseHref}api/contratar`;
  }


  /**
     * @param body   {idCotizacion,tomadorPago,fraccionPago,duracionPoliza}
     */
  contratar(body: any): Observable<AxerveSharedResponseDTO> {
    return this.http.post<AxerveSharedResponseDTO>(`${this.contratarUrl}/Pay`, body);
  }

  contratarFinal(body: any): Observable<any> {
    return this.http.post<any>(`${this.contratarFinalUrl}/Contratar`, body);
  }
}
